<template>
  <v-container fluid class="price-results" pa-0>
    <v-row row wrap no-gutters>
      <v-col cols="12" class="pa-5 pe-green lighten">
        <h2>Kaukolämpö</h2>
        <result-fields :prices="propertyInformation.prices.kaukolampo"
                       :main="true"
                       :power-consumption="propertyInformation.prices.kaukolampo.teho"
                       :compare-to-prices="currentHeatingPrices" />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="pe-green pa-5">
        <v-row align="center" justify="center">
          <button type="button" @click="openOfferRequestForm" title="Pyydä tarjous kaukolämmöstä"  class="main-btn">Pyydä tarjous kaukolämmöstä <v-icon style="margin-top: -4px;" size="26">mdi-arrow-right</v-icon></button>
        </v-row>
      </v-col>
    </v-row>
    <v-row row wrap no-gutters>
      <v-col cols="12" md="6" order="1" class="pa-5 pe-grey lighten compare-results">
        <h2>Öljylämmitys</h2>
        <result-fields :prices="propertyInformation.prices.oljy" :compare-to-prices="getCompareToPricesFor('oljy')" />
      </v-col>
      <v-col cols="12" md="6" order-md="1" order="0" class="pa-5 pe-grey compare-results">
        <h2>Maalämpö</h2>
        <result-fields :prices="propertyInformation.prices.maalampo" :compare-to-prices="getCompareToPricesFor('maalampo')" />
      </v-col>
      <v-col cols="12" md="6" order="1" class="pa-5 pe-grey compare-results">
        <h2>Sähkölämmitys</h2>
        <result-fields :prices="propertyInformation.prices.sahko" :compare-to-prices="getCompareToPricesFor('sahko')" />
      </v-col>
      <v-col cols="12" md="6" order="1" class="pa-5 pe-grey lighten compare-results">
        <h2>Ilmavesilämpöpumppu</h2>
        <result-fields :prices="propertyInformation.prices.ilmavesi" :compare-to-prices="getCompareToPricesFor('ilmavesi')" />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="pe-green pa-5">
        <v-row align="center" justify="center">
          <button type="button" @click="openOfferRequestForm" title="Pyydä tarjous kaukolämmöstä"  class="main-btn">Pyydä tarjous kaukolämmöstä <v-icon style="margin-top: -4px;" size="26">mdi-arrow-right</v-icon></button>
        </v-row>
      </v-col>
    </v-row>
    <v-row row wrap no-gutters>
      <v-col cols="12" md="6" class="pt-3">
        <v-btn color="grey lighten-4" elevation="0" style="text-transform: none;" @click="goBack" :block="$vuetify.breakpoint.xsOnly" :large="$vuetify.breakpoint.mdAndUp"><v-icon size="18" left>mdi-arrow-left</v-icon>Palaa muokkaamaan kiinteistön tietoja</v-btn>
      </v-col>
      <v-col cols="12" md="6" class="pt-3 pb-5 text-md-right">
        <v-btn color="grey lighten-4" elevation="0" style="text-transform: none;" @click="goToDetails" :block="$vuetify.breakpoint.xsOnly" :large="$vuetify.breakpoint.mdAndUp">
          <v-icon v-if="$vuetify.breakpoint.xsOnly" size="18" left>mdi-compare</v-icon>
          Katso tarkemmat tiedot ja vertailu
          <v-icon v-if="$vuetify.breakpoint.smAndUp" size="18" right>mdi-compare</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ResultFields from "./ResultFields";

  export default {
    name: "PriceResults",
    props: {
      propertyInformation: {
        type: Object,
      },
    },
    components: {
      ResultFields
    },
    data: () => {
      return {}
    },
    computed: {
      currentHeating() {
        return this.$store.state.currentHeating;
      },
      currentHeatingPrices() {
        if (this.currentHeating in this.propertyInformation.prices) {
          return this.propertyInformation.prices[this.currentHeating];
        }
        return null;
      },
    },
    methods: {
      getCompareToPricesFor(heating) {
        if (this.currentHeating in this.propertyInformation.prices) {
          if (this.currentHeating !== heating) {
            return this.propertyInformation.prices[this.currentHeating];
          }
        }

        return null;
      },
      openOfferRequestForm() {
        this.$emit('open-offer-request-form', this.propertyInformation.prices);
      },
      goBack() {
        this.$emit('go-back');
      },
      goToDetails() {
        this.$emit('go-to-details');
      }
    }
  }
</script>

